import { createSlice } from "@reduxjs/toolkit";

export const expiredModalSlice = createSlice({
  name: "ExpiredModal",
  initialState: {
    expiredModalOpen: false,
  },
  reducers: {
    setExpiredModalOpen: (state, action) => {
      state.expiredModalOpen = action.payload;
    },
  },
});

export const { setExpiredModalOpen } = expiredModalSlice.actions;

export default expiredModalSlice.reducer;
